import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import ThirdPartyParameter from '../entities/thirdpartyparameter-list'
import appconst from '@/lib/appconst';


interface ThirdPartyParameterState extends ListState<ThirdPartyParameter> {
    total: any;
    ThirdPartyParameterInfo: ThirdPartyParameter,
}

class ThirdPartyParameterMutations extends ListMutations<ThirdPartyParameter>{

}
class ThirdPartyParameterInfo extends ListModule<ThirdPartyParameterState, any, ThirdPartyParameter>{
    state = {
        totalCount: 0,
        total: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ThirdPartyParameter>(),
        loading: false,
        ThirdPartyParameters: ThirdPartyParameter,
        id: 0,

    }
    actions = {
        async getAll(context: ActionContext<ThirdPartyParameterState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/MainlandFreight/GetThirdPartyParameterList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<ThirdPartyParameter>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async Add(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/MainlandFreight/AddThirdPartyParameter', payload.data);
        },
        async updateStatus(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/MainlandFreight/EditThirdPartyStatus', payload.data);
        },
        //async GetFreight(context: ActionContext<ThirdPartyParameterState, any>, payload: any) {
        //    let rep = await Ajax.post('/api/services/app/MainlandFreight/GetFreight', payload.data);
        //    let page = rep.data.result;
        //    context.state.total = page;
        //},
        async editEndTime(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/MainlandFreight/EditThirdPartyEndTime', payload.data);
        },
    };
}

const thirdinfo = new ThirdPartyParameterInfo();
export default thirdinfo;